import ActiveRecord from '@mysidewalk/active-record';

import AnalyticsRecordSource from './AnalyticsRecordSource.js';

class AnalyticsRecord extends ActiveRecord {}

AnalyticsRecord.$AR = {
  SourceClass: AnalyticsRecordSource,
};

export default AnalyticsRecord;
export { AnalyticsRecordSource };
